import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api, qk, unwrap } from '../api/client';
import { useAuth } from '../app/auth';

// Bell = pending approvals + unread alerts (GET /notifications/summary, refreshed every minute); click opens My approvals.
export function NotificationBell() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const user = useAuth((s) => s.user);
  const summary = useQuery({
    queryKey: qk.one('core', 'notifications', 'summary'),
    queryFn: () => unwrap(api.GET('/api/v1/notifications/summary')),
    enabled: user !== null,
    refetchInterval: 60_000,
  });
  const count = (summary.data?.pendingApprovals ?? 0) + (summary.data?.unreadAlerts ?? 0);
  return (
    <button type="button" className="bell" title={t('topbar.notifications')} aria-label={t('topbar.notificationsCount', { count })} onClick={() => void nav('/wf/inbox')}>
      🔔{count > 0 && <i aria-hidden="true">{count}</i>}
    </button>
  );
}
